<template>
  <div id="experience-form" class="modal-form" v-if="formData">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <form class="formData-form" @submit.prevent="onSubmit">
            <div class="row">
              <div class="col-md-3">
                <input
                  type="submit"
                  class="btn btn-primary form-control"
                  value="Save & Publish"
                  @click="saveAndPublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                />
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="unpublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Unpublish
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="saveDraft"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Save
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary close-button form-control"
                  @click="onClickCloseButton"
                >
                  Close
                </button>
              </div>
            </div>
            <h1 class="form-title">Add/Edit Experience</h1>
            <fieldset>
              <legend>Basic information</legend>
              <div class="form-group row">
                <label for="title" class="form-label col-md-2"
                  >Experience Name *</label
                >
                <div class="col-md-10">
                  <!-- <input
                    type="text"
                    class="form-control"
                    id="title"
                    v-model="$v.formData.title.$model"
                    required
                    :class="{
                      'is-invalid': $v.formData.title.$error,
                      'is-valid':
                        $v.formData.title.$error == false &&
                        $v.formData.title.$model != '',
                    }"
                  /> -->
                  <ExperienceTextBox
                    ref="expPicker"
                    @new="onPickNewExperienceTitle"
                  />
                  <div class="invalid-feedback">Please enter a title.</div>
                </div>
              </div>
              <div class="form-group row">
                <label for="email" class="form-label col-md-2">Email *</label>
                <div class="col-md-10">
                  <input
                    type="email"
                    class="form-control"
                    id="email"
                    v-model="$v.formData.email.$model"
                    required
                    :class="{
                      'is-invalid': $v.formData.email.$error,
                      'is-valid':
                        $v.formData.email.$error == false &&
                        $v.formData.email.$model != '',
                    }"
                  />
                  <div class="invalid-feedback">Please enter a Email.</div>
                </div>
              </div>
              <div class="form-group row">
                <label for="email" class="form-label col-md-2">URL</label>
                <div class="col-md-10">
                  <input
                    type="url"
                    class="form-control"
                    id="websiteLink"
                    v-model="formData.websiteLink"
                  />
                </div>
              </div>
              <LocationPicker
                :country="formData.country"
                :region="formData.region"
                :district="formData.district"
                @change="onLocationPickerChanged"
                ref="locationPicker"
              />
              <div class="form-group row">
                <label for="latitude" class="form-label col-md-2"
                  >Location*</label
                >
                <div class="col-md-10">
                  <div class="form-group row">
                    <label for="latitude" class="form-label col-md-3">
                      <div class="label-icon-box">
                        <i class="label-icon fas fa-map-marker-alt"></i>
                      </div>
                      Latitude
                    </label>
                    <div class="col-md-3">
                      <input
                        type="number"
                        step="0.0000001"
                        min="-90"
                        max="90"
                        class="form-control"
                        id="latitude"
                        v-model="$v.formData.position.latitude.$model"
                        required
                        :class="{
                          'is-invalid': $v.formData.position.latitude.$error,
                          'is-valid':
                            $v.formData.position.latitude.$error == false &&
                            $v.formData.position.latitude.$model != '',
                        }"
                      />
                      <div class="invalid-feedback">
                        Please enter a valid latitude.
                      </div>
                    </div>
                    <label for="longitude" class="form-label col-md-2"
                      >Longitude</label
                    >
                    <div class="col-md-3">
                      <input
                        type="number"
                        step="0.0000001"
                        min="-180"
                        max="180"
                        class="form-control"
                        id="longitude"
                        v-model="$v.formData.position.longitude.$model"
                        required
                        :class="{
                          'is-invalid': $v.formData.position.longitude.$error,
                          'is-valid':
                            $v.formData.position.longitude.$error == false &&
                            $v.formData.position.longitude.$model != '',
                        }"
                      />
                      <div class="invalid-feedback">
                        Please enter a valid longitude.
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="what3words" class="form-label col-md-3">
                      <div class="label-icon-box">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21.265"
                          height="16.799"
                          viewBox="0 0 21.265 16.799"
                        >
                          <g transform="translate(-379.638 -183.044)">
                            <path
                              d="M380.873,199.843a1.236,1.236,0,0,1-1.162-1.655l5.168-14.328a1.235,1.235,0,0,1,2.324.838l-5.169,14.328A1.236,1.236,0,0,1,380.873,199.843Z"
                              fill="#fff"
                            />
                            <path
                              d="M411.208,199.843a1.236,1.236,0,0,1-1.162-1.655l5.168-14.328a1.235,1.235,0,0,1,2.324.838l-5.168,14.328A1.236,1.236,0,0,1,411.208,199.843Z"
                              transform="translate(-23.522 0)"
                              fill="#fff"
                            />
                            <path
                              d="M441.543,199.843a1.236,1.236,0,0,1-1.162-1.655l5.168-14.328a1.235,1.235,0,0,1,2.324.838L442.7,199.027A1.235,1.235,0,0,1,441.543,199.843Z"
                              transform="translate(-47.044 0)"
                              fill="#fff"
                            />
                          </g>
                        </svg>
                      </div>
                      What3Words
                    </label>
                    <div class="col-md-9">
                      <input
                        type="text"
                        class="form-control"
                        id="what3words"
                        v-model="formData.what3words"
                        ref="what3words"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label for="socialIdentifiers" class="form-label col-md-2"
                  >Hashtag *</label
                >
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="socialIdentifiers"
                    v-model="$v.formData.socialIdentifiers.$model"
                    required
                    :class="{
                      'is-invalid': $v.formData.socialIdentifiers.$error,
                      'is-valid':
                        $v.formData.socialIdentifiers.$error == false &&
                        $v.formData.socialIdentifiers.$model != '',
                    }"
                  />
                  <div class="invalid-feedback">Please enter a Hashtag.</div>
                </div>
              </div>
              <div class="form-group row">
                <label for="description" class="form-label col-md-2"
                  >Description*</label
                >
                <div class="col-md-10">
                  <textarea
                    type="text"
                    class="form-control"
                    id="description"
                    rows="4"
                    required
                    v-model="$v.formData.description.$model"
                    :class="{
                      'is-invalid': $v.formData.description.$error,
                      'is-valid':
                        $v.formData.description.$error == false &&
                        $v.formData.description.$model != '',
                    }"
                  />
                  <div class="invalid-feedback">Please enter a Hashtag.</div>
                </div>
              </div>
              <div class="form-group row">
                <label for="telephone" class="form-label col-md-2"
                  >Telephone Number</label
                >
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    id="telephone"
                    v-model="formData.telephone"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="address" class="form-label col-md-2"
                  >Address *</label
                >
                <div class="col-md-10">
                  <textarea
                    rows="3"
                    class="form-control"
                    id="address"
                    v-model="$v.formData.address.$model"
                    required
                    :class="{
                      'is-invalid': $v.formData.address.$error,
                      'is-valid':
                        $v.formData.address.$error == false &&
                        $v.formData.address.$model != '',
                    }"
                  />
                  <div class="invalid-feedback">Please enter a Address.</div>
                </div>
              </div>
              <OpenHour v-model="formData.openingTime" ref="openingTime" />
            </fieldset>
            <fieldset>
              <legend>Category*</legend>
              <CategoryPicker
                v-model="$v.formData.categories.$model"
                :class="{
                  'is-invalid': $v.formData.categories.$error,
                  'is-valid':
                    $v.formData.categories.$error == false &&
                    $v.formData.categories.$model != '',
                }"
              />
              <div class="invalid-feedback">Please select a Category.</div>
            </fieldset>
            <fieldset>
              <legend>Target Group*</legend>
              <TravelerTypePicker
                v-model="$v.formData.travelerTypes.$model"
                selectText="selectedExperience"
                :class="{
                  'is-invalid': $v.formData.travelerTypes.$error,
                  'is-valid':
                    $v.formData.travelerTypes.$error == false &&
                    $v.formData.travelerTypes.$model != '',
                }"
              />
              <div class="invalid-feedback">Please select a Target Group.</div>
            </fieldset>
            <fieldset>
              <legend>Social Media Channels</legend>
              <div class="form-group row">
                <label for="facebookLink" class="form-label col-md-1">
                  <i class="label-icon fab fa-facebook"></i>
                </label>
                <div class="col-md-11">
                  <input
                    type="url"
                    class="form-control"
                    id="facebookLink"
                    placeholder="Facebook"
                    v-model="formData.facebookLink"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="instagramLink" class="form-label col-md-1">
                  <i class="label-icon fab fa-instagram"></i>
                </label>
                <div class="col-md-11">
                  <input
                    type="url"
                    class="form-control"
                    id="instagramLink"
                    placeholder="Instagram"
                    v-model="formData.instagramLink"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="twitterLink" class="form-label col-md-1">
                  <i class="label-icon fab fa-twitter"></i>
                </label>
                <div class="col-md-11">
                  <input
                    type="url"
                    class="form-control"
                    id="twitterLink"
                    placeholder="Twitter"
                    v-model="formData.twitterLink"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="pinterestLink" class="form-label col-md-1">
                  <i class="label-icon fab fa-pinterest"></i>
                </label>
                <div class="col-md-11">
                  <input
                    type="url"
                    class="form-control"
                    id="pinterestLink"
                    placeholder="Pinterest"
                    v-model="formData.pinterestLink"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="youtubeLink" class="form-label col-md-1">
                  <i class="label-icon fab fa-youtube"></i>
                </label>
                <div class="col-md-11">
                  <input
                    type="url"
                    class="form-control"
                    id="youtubeLink"
                    placeholder="Youtube"
                    v-model="formData.youtubeLink"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="vimeoLink" class="form-label col-md-1">
                  <i class="label-icon fab fa-vimeo"></i>
                </label>
                <div class="col-md-11">
                  <input
                    type="url"
                    class="form-control"
                    id="vimeoLink"
                    placeholder="Vimeo"
                    v-model="formData.vimeoLink"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="vkLink" class="form-label col-md-1">
                  <i class="label-icon fab fa-vk"></i>
                </label>
                <div class="col-md-11">
                  <input
                    type="url"
                    class="form-control"
                    id="vkLink"
                    placeholder="VK"
                    v-model="formData.vkLink"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label for="wechatLink" class="form-label col-md-1">
                  <i class="label-icon fab fa-wechat"></i>
                </label>
                <div class="col-md-11">
                  <input
                    type="url"
                    class="form-control"
                    id="wechatLink"
                    placeholder="WeChat"
                    v-model="formData.wechatLink"
                  />
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend>Image</legend>
              <div>
                <ImageUploadButton
                  newColor="var(--experience-color)"
                  ref="imageUploader"
                  :imageUrl="
                    formData && formData.thumbnailUrl
                      ? formData.thumbnailUrl
                      : ''
                  "
                  @clear="onClearUploadImage"
                />
              </div>
            </fieldset>
            <fieldset>
              <legend>Affiliations</legend>
              <div class="form-group row">
                <div class="col-md-6">
                  <label class="container-checkbox">
                    Any experience and tour can connect with mine without
                    approval.
                    <input
                      type="radio"
                      checked="checked"
                      name="radio"
                      v-model="
                        formData.settings.affiliationConnectionAutoAccept
                      "
                      :value="true"
                    />
                    <span class="checkmark"></span>
                  </label>
                </div>
                <div class="col-md-6">
                  <label class="container-checkbox">
                    Any experience and tour can connect with mine with my
                    approval.
                    <input
                      class="checkmark"
                      type="radio"
                      name="radio"
                      v-model="
                        formData.settings.affiliationConnectionAutoAccept
                      "
                      :value="false"
                    />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </div>
              <div class="form-group row">
                <label class="form-label col-md-2">EXPERIENCES</label>
                <div class="col-md-10">
                  <AffiliationPicker
                    :contentId="id"
                    buttonColor="var(--experience-color)"
                    @click:add="saveDraftWithoutClosing"
                  />
                </div>
              </div>
              <div class="form-group row">
                <label class="form-label col-md-2"
                  >ASSOCIATIONS / GROUPS / CERTIFICATIONS</label
                >
                <div class="col-md-10">
                  <GroupPicker
                    :contentId="id"
                    buttonColor="var(--experience-color)"
                    @click:add="saveDraftWithoutClosing"
                  />
                </div>
              </div>
            </fieldset>
            <fieldset>
              <legend>Distribution</legend>
              <div class="form-group row">
                <label
                  class="form-label col-md-2"
                  style="line-height: 1.2"
                ></label>
                <div class="col-md-10">
                  <DistributionPicker
                    :contentId="id"
                    buttonColor="var(--experience-color)"
                    @click:add="saveDraftWithoutClosing"
                  />
                </div>
                <div class="form-group row aggregation col-md-12 d-flex">
                  <div class="col-md-6 d-flex">
                    <label class="container-checkbox">
                      Only distribute content after I have manually approved it.
                      <input
                        type="radio"
                        v-model="formData.settings.momentConnectionAutoAccept"
                        name="momentConnectionAutoAccept"
                        :value="false"
                      />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                  <div class="col-md-6 d-flex">
                    <label class="container-checkbox">
                      All content aggregated for this experience is
                      automatically approved and distributed to all channels
                      <input
                        type="radio"
                        v-model="formData.settings.momentConnectionAutoAccept"
                        name="momentConnectionAutoAccept"
                        :value="true"
                      />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                </div>
              </div>
            </fieldset>
            <EnwokeDeclarationFieldset
              v-model="formData.isAcceptedEnwokeAgreement"
              @delete="onDelete"
              contentName="experience"
            />
            <div class="row">
              <div class="col-md-3">
                <input
                  type="submit"
                  class="btn btn-primary form-control"
                  value="Save & Publish"
                  @click="saveAndPublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                />
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="unpublish"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Unpublish
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary form-control"
                  @click="saveDraft"
                  :disabled="!formData.isAcceptedEnwokeAgreement"
                >
                  Save
                </button>
              </div>
              <div class="col-md-3">
                <button
                  class="btn btn-secondary close-button form-control"
                  @click="onClickCloseButton"
                >
                  Close
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email, decimal } from "vuelidate/lib/validators";
import ExperienceTextBox from "@/components/ExperienceTextBox";
import LocationPicker from "@/components/LocationPicker";
import CategoryPicker from "@/components/CategoryPicker";
import TravelerTypePicker from "@/components/TravelerTypePicker";
import ExperiencePicker from "@/components/ExperiencePicker";
import EnwokeDeclarationFieldset from "@/components/EnwokeDeclarationFieldset";
import ImageUploadButton from "@/components/ImageUploadButton";
import AddContentButton from "@/components/AddContentButton";
import Modal from "@/components/Modals/Modal.vue";
import AffiliationPicker from "@/components/AffiliationPicker";
import GroupPicker from "@/components/GroupPicker";
import DistributionPicker from "@/components/DistributionPicker";
import OpenHour from "@/components/OpenHour";
import _ from "lodash";

export default {
  name: "ExperienceForm",
  components: {
    ExperienceTextBox,
    LocationPicker,
    CategoryPicker,
    TravelerTypePicker,
    ExperiencePicker,
    ImageUploadButton,
    EnwokeDeclarationFieldset,
    AddContentButton,
    AffiliationPicker,
    GroupPicker,
    DistributionPicker,
    Modal,
    OpenHour,
  },
  props: {
    content: {
      type: Object,
    },
  },
  data() {
    return {
      regions: [],
      districts: [],
      modalAffiliation: false,
      formData: {
        id: null,
        title: "",
        description: "",
        telephone: "",
        email: "",
        address: "",
        country: "",
        region: "",
        district: "",
        socialIdentifiers: "",
        categories: [],
        travelerTypes: [],
        experiences: [],
        facebookLink: "",
        instagramLink: "",
        twitterLink: "",
        pinterestLink: "",
        youtubeLink: "",
        vimeoLink: "",
        vkLink: "",
        wechatLink: "",
        sliderImageUrls: [],
        thumbnailUrl: "",
        websiteLink: "",
        what3words: "",
        position: {
          latitude: "",
          longitude: "",
        },
        openingTime: [],
        status: "PUBLISH",
        isAcceptedEnwokeAgreement: false,
        settings: {
          affiliationConnectionAutoAccept: true,
          momentConnectionAutoAccept: false,
        },
      },
      listExperience: [
        {
          id: "1",
          name: "Wing Hotel",
          status: "Confirmed",
        },
        {
          id: "2",
          name: "Arts Museum",
          status: "Confirmed",
        },
        {
          id: "3",
          name: "Vespa Restaurant",
          status: "Confirmed",
        },
      ],
      listGroup: [
        {
          id: "1",
          name: "Experience Mekong Collection",
          status: "Confirmed",
        },
        {
          id: "2",
          name: "Thailand Hotel Association",
          status: "Confirmed",
        },
        {
          id: "3",
          name: "Bangkok  Hotel Association",
          status: "Requested",
        },
      ],
    };
  },
  validations: {
    formData: {
      title: {
        required,
      },
      email: {
        required,
        email,
      },
      country: {
        required,
      },
      region: {
        required,
      },
      position: {
        latitude: {
          valid: (val) => {
            if (val) {
              return isFinite(val) && Math.abs(val) <= 90;
            } else {
              return false;
            }
          },
        },
        longitude: {
          valid: (val) => {
            if (val) {
              return isFinite(val) && Math.abs(val) <= 180;
            } else {
              return false;
            }
          },
        },
      },
      socialIdentifiers: {
        required,
      },
      description: {
        required,
      },
      address: {
        required,
      },
      categories: {
        required,
      },
      travelerTypes: {
        required,
      },
    },
  },
  computed: {
    id() {
      return this.content ? this.content.id : this.formData.id;
    },
  },
  mounted() {
    if (this.content) {
      this.prepare(this.content);
    }
  },
  methods: {
    async prepare(content) {
      const formData = _.merge(this.formData, content); // Create a copy.

      if (!formData.position) {
        formData.position = {
          latitude: "",
          longitude: "",
        };
      }
      if (formData.categories && formData.categories.length > 0) {
        formData.categories = formData.categories.map((it) => it.id);
      }
      if (formData.travelerTypes && formData.travelerTypes.length > 0) {
        formData.travelerTypes = formData.travelerTypes.map((it) => it.id);
      }
      if (formData.platforms && formData.platforms.length > 0) {
        formData.platforms = formData.platforms.map((it) => it.id);
      }
      if (formData.country && formData.country.id) {
        formData.country = formData.country.id;
      }
      if (formData.region && formData.region.id) {
        formData.region = formData.region.id;
      }
      if (formData.district && formData.district.id) {
        formData.district = formData.district.id;
      }
      if (formData.experiences && formData.experiences.results) {
        formData.experiences = formData.experiences.results;
      }

      this.formData = formData;

      await this.$refs.openingTime.revalidate();
      await this.$refs.locationPicker.revalidate(formData);

      this.$refs.expPicker.syncData(formData);
    },
    async onPickNewExperienceTitle(data) {
      this.formData.title = data.title;
      this.formData.address = data.address;
      if (data.country) {
        this.formData.country = data.country;
      }
      if (data.region) {
        this.formData.region = data.region;
      }
      if (data.district) {
        this.formData.district = data.district;
      }
      if (data.position && data.position.latitude && data.position.longitude) {
        this.formData.position.latitude = data.position.latitude;
        this.formData.position.longitude = data.position.longitude;
      }
      this.formData.what3words = data.what3words;

      await this.$refs.locationPicker.revalidate(this.formData);
    },
    async uploadImages() {
      if (this.$refs.imageUploader) {
        return this.$refs.imageUploader.upload();
      } else {
        return null;
      }
    },
    onSubmit(ev) {
      ev.preventDefault();
    },
    saveAndPublish(ev) {
      this.save("PUBLISH");
    },
    saveDraft(ev) {
      this.save("DRAFT");
    },
    saveDraftWithoutClosing() {
      this.save("DRAFT", false);
    },
    unpublish(ev) {
      this.save("UNPUBLISH");
    },
    async save(status = "PUBLISH", closeAfterSave = true) {
      if (status === "PUBLISH" && !this.formData.isAcceptedEnwokeAgreement)
        return;

      if (!this.formData.title || this.formData.title.trim() === "") {
        this.formData.title = "Untitled";
      }

      this.formData.status = status;

      const files = await this.uploadImages();
      if (files && files.length > 0) {
        this.formData.sliderImageUrls = files.map((file) => file.url);
        this.formData.thumbnailUrl = files[0].url;
      }

      let promise = null;

      let saveData = _.merge({}, this.formData); // Clone data for saving.

      // Finalize save data.
      if (saveData.experiences && saveData.experiences.length > 0) {
        saveData.experiences = saveData.experiences.map((it) => it.id);
      }
      if (
        saveData.position &&
        saveData.position.latitude &&
        saveData.position.longitude
      ) {
        saveData.position.latitude = parseFloat(saveData.position.latitude);
        saveData.position.longitude = parseFloat(saveData.position.longitude);
      } else {
        delete saveData.position;
      }
      if (!saveData.country) {
        delete saveData.country;
      }
      if (!saveData.region) {
        delete saveData.region;
      }
      if (!saveData.district) {
        delete saveData.district;
      }

      this.$v.$touch();
      if (!this.$v.$invalid || status != "PUBLISH") {
        if (this.id) {
          promise = this.$repo.exp.updateExperience(saveData);
        } else {
          promise = this.$repo.exp.createExperience(saveData);
        }

        promise
          .then((data) => {
            this.formData.id = data.id;
            if (closeAfterSave) {
              this.$toasted.show("Save data successfully.", {
                type: "success",
                duration: 3000,
                position: "bottom-right",
              });
              this.closeForm();
            }
          })
          .catch((err) => {
            console.error(err);
            if (closeAfterSave) {
              this.$toasted.show("Something went wrong.", {
                type: "error",
                duration: 3000,
                position: "bottom-right",
              });
            }
          });
      }
    },
    async onDelete() {
      if (this.id) {
        await this.$repo.exp.deleteExperience(this.id);
        this.closeForm();
      }
    },
    onClearUploadImage() {
      this.formData.sliderImageUrls = [];
      this.formData.thumbnailUrl = "";
    },
    onClickCloseButton(ev) {
      ev.preventDefault();
      this.closeForm();
    },
    closeForm() {
      this.$emit("close");
    },
    onLocationPickerChanged(data) {
      this.formData.country = data.country;
      this.formData.region = data.region;
      this.formData.district = data.district;
    },
    onCloseModalAffiliations() {
      this.modalAffiliation = false;
    },
  },
};
</script>

<style lang="scss" scoped>
$main-color: #1da1f2;

#experience-form {
  .form-title {
    color: $main-color;
  }

  .label-icon-box {
    background-color: #b9b9b9;
    color: #fff;
    display: inline-block;
    width: 40px;
    height: 40px;
    vertical-align: middle;
    margin-right: 10px;
    text-align: center;
    position: relative;

    .label-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .label-icon {
    font-size: 2rem;
  }

  input[type="submit"].btn-primary {
    background-color: $main-color;
    border-color: $main-color;
  }

  /* The container */
  .container-checkbox {
    display: block;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
    font-size: 14px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    color: #fff;
  }

  /* Hide the browser's default checkbox */
  .container-checkbox input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 7px;
    left: 10px;
    height: 15px;
    width: 15px;
    background-color: #eee;
  }

  .aggregation {
    color: #fff;
  }

  /* On mouse-over, add a grey background color */
  .container-checkbox:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .container-checkbox input:checked ~ .checkmark {
    background-color: $main-color;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .container-checkbox input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .container-checkbox .checkmark:after {
    left: 6px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
}
</style>
